import React from 'react';
import {getAntd, getEcCom, getLabel} from '../../util/convert';

import {inject, observer} from "mobx-react";

@inject("showContentStore")
@observer
export default class Main extends React.Component {
    constructor() {
        super();
        this.state = {showAll: false};
    }

    componentDidMount() {
      
        const {WeaTools} = getEcCom();
        const {message} = getAntd();
        const {ls} = WeaTools;
        const {isAutoApprove = false, showContentStore, requestid = '', nodeid = '', sessionkey = ''} = this.props;
        const {changeSpining4True, startInterval} = showContentStore;
        if (isAutoApprove) {
            changeSpining4True();
            startInterval(requestid, nodeid, sessionkey);
        }
        if (!isAutoApprove) {
            if (ls&&ls.getJSONObj(sessionkey) == null) {
                ls&&ls.set(sessionkey, {showMessage: 1});
                message&&message.success(getLabel(530822, '流程处理成功'));
            }
        }
    }

    render() {
        const {isAutoApprove = false, showContentStore, requestid = '', nodeid = ''} = this.props;
        const {spinning} = showContentStore;

        return (
            <div>
                {isAutoApprove && spinning ? this.getContent(spinning) : this.getContent(false)}
            </div>
        )
    }

    getContent(spinning) {
        const {Spin} = getAntd();
        const {showAll} = this.state;
        const {nextNodeNames, operators = [], nextNodeids = '', showContentStore, isAutoApprove} = this.props;
        const {auto2NextNodeNames = "", auto2Operators = [], auto2NextNodeids = ""} = showContentStore;
        let nextNodeNamess = "";
        let nextNodeOperatorss = "";
        let nextNodeidss = "";
        if (isAutoApprove && !spinning&&auto2NextNodeNames!="") {
            nextNodeNamess = auto2NextNodeNames;
            nextNodeOperatorss = auto2Operators;
            nextNodeidss = auto2NextNodeids;
        } else {
            nextNodeNamess = nextNodeNames;
            nextNodeOperatorss = operators;
            nextNodeidss = nextNodeids;
        }

        return <div className="wf-confirm-msg">
            {Spin&&<Spin tip={getLabel(530824, '当前流程后续节点存在系统自动处理情况，节点信息正在更新，请稍候...')} spinning={spinning}>
                </Spin>}
                {!spinning && <div className="wf-confirm-msg-content">

                    {(nextNodeidss != '' || nextNodeNamess != '') &&
                    <div className="wf-confirm-msg-title">
                        <div
                            className="wf-confirm-msg-receiver-title">{getLabel(530823, '流程到达节点')}: {nextNodeNamess}</div>
                    </div>
                    }
                    {nextNodeOperatorss && nextNodeOperatorss.length > 0 &&
                    <div className="wf-confirm-msg-operators">
                        <div className="wf-confirm-msg-receiver-title">{getLabel(15525, '接收人')}：</div>
                        <div className="wf-confirm-msg-receiver-users" style={{width:"92%"}}>

                            {
                                nextNodeOperatorss && nextNodeOperatorss.map((item, index) => {
                                    if (index >= 20 && !showAll)
                                        return null;
                                    return this.getOperatorObj(item);
                                })
                            }
                            {
                                nextNodeOperatorss.length > 20 && !showAll &&
                                <i className="icon-coms-down" onClick={this.controlShowAll.bind(this, true)}/>
                            }

                        </div>
                        <div style={{left:"96%",position:"absolute"}}>
                            {
                                nextNodeOperatorss.length > 20 && showAll &&
                                <i className="icon-coms-up" onClick={this.controlShowAll.bind(this, false)}/>
                            }

                        </div>
                    </div>
                    }
                </div>}

        </div>
    }

    getOperatorObj(item) {
        let obj = new Array();
        if(Number(item.operatortype) == 0) {
            if (!!item.beagentid && item.operatorid) {    //存在代理
                obj.push(<a className="wea-hrm-card" href={`javaScript:openhrm(${item.beagentid})`}
                            onClick={event => window.pointerXY(event)}>{item.beagentname}</a>);
                obj.push(<span className="wf-confirm-msg-connect-symbol">-></span>);
            }
            item.operatorid && obj.push(<a className="wea-hrm-card" href={`javaScript:openhrm(${item.operatorid})`}
                                           onClick={event => window.pointerXY(event)}>{item.operatorname}</a>);
        }else if(Number(item.operatortype) == 2){
            obj.push(<span>{item.operatorname}</span>);
        }else {
            obj.push(<a target={`_blank`}  href={`/spa/crm/static/index.html#/main/crm/customerView?customerId=${item.operatorid}`} >{item.operatorname}</a>);
        }
        return <span className="wf-confirm-msg-user">{obj}</span>;
    }

    controlShowAll(bool) {
        this.setState({showAll: bool})
    }

}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/topPropmpt/SubmitShowInfo.js